export const DEFAULT_LAYOUT_NAME = 'Default';

export const SUCCESSFUL_SAVE_MESSAGE = 'Your filter settings have been saved';
